import KeyboardNavigation from '../../grid/keyboardNavigation';
import InlineEditors from '../../controllers/inlineEditors';

export default instance => {
  instance.ext.inlineEditors.attachEvent('onEditEnd', ({ id, columnName }) => {
    InlineEditors.onEditEnd(id, columnName);
    KeyboardNavigation.onEditEnd(id, columnName);
  });
};
